import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_REC029_Request,
  IAPI_REC029_Response,
  IAPI_REC010_Request,
  IAPI_REC010_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 振込情報詳細参照
// API仕様書_収納・納付請求処理
const httpAPI_REC029 = async (
  param: IAPI_REC029_Request
): Promise<IAPI_REC029_Response> => {
  let res = await http.post(ApiUrl.API_REC029, {
    ...param,
  });

  return res.data;
};

// 振込情報詳細更新
// API仕様書_収納・納付請求処理
const httpAPI_REC010 = async (
  param: IAPI_REC010_Request
): Promise<IAPI_REC010_Response> => {
  let res = await http.post(ApiUrl.API_REC010, {
    ...param,
  });
  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_REC029, httpAPI_REC010, httpAPI_APP016 };
